import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Routes, Router, RouterModule } from '@angular/router';

import { Cookie } from 'ng2-cookies/ng2-cookies';
import { TranslateService } from 'ng2-translate';

import { ProjectsService } from '../services/projects.service';
import { AlertManagerService } from '../../../shared/services/alert-manager.service';

import { ProjectModel } from '../../../modules/models';
import { WorkConstants } from '../work.const';
import { Confrontation } from '../../../shared/';

import { ContextMenuService } from 'angular2-contextmenu';

declare var $: any;

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  providers: [ProjectsService],
})
export class ProjectsComponent implements OnInit {

  hiddnSprint = false;
  projectList: Array<ProjectModel> = [];
  tepProjectList: Array<ProjectModel> = [];
  searchKay: string;
  inputFilter: string;
  pageId: number = 1;
  pageCount: number = 1;
  perPage: number = 0;
  projectCount: number = 0;

  workConstants: any = WorkConstants;

  constructor(
    private alertService: AlertManagerService,
    private router: Router,
    private translate: TranslateService,
    private projectsService: ProjectsService,
    private contextMenuService: ContextMenuService
  ) { }

  ngOnInit() {
    this.loadProjects(this.pageId);    
  }

  toggleSprint(event) {
    $(event.srcElement.closest('td')).find('.dd').toggle();
    $(event.srcElement.closest('td')).find('.fa-caret-right').toggle();
    $(event.srcElement.closest('td')).find('.fa-caret-down').toggle();
  }

  loadProjects(pageId) {
    this.projectsService.loadProjects(pageId).subscribe(
      result => {
        this.projectList = result.projects;
        this.tepProjectList = result.projects;
        this.inputFilter = null;
        this.pageCount = result.pageCount;
        this.perPage = result.perPage;
        this.pageId = result.pageId;
        this.projectCount = result.projectCount;
        if(this.pageId == this.pageCount){
          $('.pagination-next').hide();
        }else{
          $('.pagination-next').show();
        }

        this.scrollThePage();
      }
      
    );
  }

  searchProjects(key: string) {
    if (key !== undefined) {
      this.projectsService.searchProjects(key).subscribe(
        result => {
          this.projectList = result.projects;
          if (this.projectList.length === 0) {
            this.loadProjects(this.pageId);
            this.alertService.info({ title: "WARNING", msg: this.translate.instant("NO_PROJECTS") });
          }
        },
        error => {
          this.loadProjects(this.pageId);
          this.alertService.error({ title: "WARNING", msg: this.translate.instant("SERVER_ERROR") });
        });
    }
  }

  public onContextMenu($event: MouseEvent, project_sprints: any): void {
    let items: any = project_sprints.length === 0 ? [{ html: (project_sprints) => 'No Sprint', click: (project_sprints) => '' }] : [];
    project_sprints.forEach(element => {
      let item = {
        html: (project_sprints) => element.title,
        click: (project_sprints) => this.nevigate(element.project_id, element.id)
      };
      items.push(item);
    });
    this.contextMenuService.show.next({
      actions: items,
      event: $event,
      item: project_sprints,
    });
    $event.preventDefault();
    $event.stopPropagation();
  }

  nevigate(project_id, sprint_id) {
    let url = "mongoose/works/projects/" + project_id + "/sprint/" + sprint_id
    this.router.navigate([url]);
  }

  projectFilter(v: any) {
    if (!v) {
      this.projectList = Object.assign([], this.tepProjectList);
    } else {
      let val = v.toLowerCase();
      this.projectList = Object.assign([], this.tepProjectList);
      this.projectList = this.projectList.filter(ele => {
        let isProjectName = ele.project_name ? ele.project_name.toLowerCase().indexOf(val) > -1 : false;
        let isProjectStatus = ele.project_status ? ele.project_status.toLowerCase().indexOf(val) > -1 : false;
        return isProjectName || isProjectStatus;
      });
    }
  }

  // viewSprint(projectId,sprintId){
  //   this.nevigate(projectId,sprintId)
  //   // console.log(projectId,sprintId);
  //   //  var url1 = "mongoose/works/projects/"+projectId+"/sprint/"+sprintId
  //   // var x = this.router.navigate([url1]);
  //   // console.log(x);
  //   //window.location.href = x;
  // }

  /**
   * kaushalya
   * get project list according to the pagination
   * 2017-07-3
   * @param pageId 
   */
  pageChanged(pageId) {
    console.log(pageId);
    this.loadProjects(pageId);
  }

  /**
   * kauhslya
   * 2017-08-14
   * scroll The Page
   * @param event
  //  */
  scrollThePage(){
    window.scrollTo(0,0);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/work/components/projects.component.ts